<template>
  <div>
    <v-toolbar dense
               src="https://www.cellmark.com/wp-content/uploads/2019/09/printing-and-writing-papers.jpg"
    >
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        width="800"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="blue"
            v-bind="attrs"
            v-on="on"
            outlined
            class="black--text"
          >
            Připsat kredity
          </v-btn>
        </template>
        <AddCreditForm
          @data-saved="dialog = false; initialize()"
          v-if="dialog"
        ></AddCreditForm>
      </v-dialog>
    </v-toolbar>
    <template>
      <v-card>
        <v-card-title>
          Transakce
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledat"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :items-per-page="250"
          :headers="headers"
          :items="transactions"
          :search="search"
          :loading="loading"
          :custom-sort="sortByDate"
        >
          <template v-slot:item.price="{ item }">
            <div :class="getPaymentTypeColor(item.paymentTypeId)">{{ item.price }}</div>
          </template>
          <template v-slot:item.show="{ item }">
            <v-icon
              @click="showInvoice(item)"
              v-if="item.invoice"
            >mdi-eye</v-icon>
          </template>
          </v-data-table>
        <v-btn
          @click="initialize"
          color="primary"
          class="float-right my-4 mr-5"
        >Načíst další
        </v-btn>
        <v-dialog v-model="invoiceDialog">
          <v-card>
            <InvoiceView
              v-if="invoiceDialog"
              :invoice="displayedInvoice"
            ></InvoiceView>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </div>
</template>

<script>
import AddCreditForm from '@/components/forms/admin/AddCreditForm'
import InvoiceView from '@/components/InvoiceView'
export default {
  name: 'Transactions',
  components: { InvoiceView, AddCreditForm },
  data () {
    return {
      page: 1,
      loading: true,
      invoiceDialog: false,
      displayedInvoice: null,
      dialog: false,
      transactions: [],
      search: null,
      headers: [
        { text: 'ID', value: 'id', align: 'start', sortable: true },
        { text: 'Typ transakce', value: 'type', align: 'start', sortable: true },
        { text: 'Objednávka', value: 'orderId' },
        { text: 'E-mail uživetele', value: 'userEmail' },
        { text: 'Jméno a příjmení uživatele', value: 'userFullName' },
        { text: 'E-mail admina', value: 'adminEmail' },
        { text: 'Poznámky', value: 'comment' },
        { text: 'Datum', value: 'createdStr' },
        { text: 'Částka', value: 'price' },
        { text: 'Stav', value: 'status' },
        { text: 'Zobrazit', value: 'show', sortable: false }
      ]
    }
  },
  methods: {
    initialize () {
      this.loading = true
      // this.$http.get('/admin/transactions')
      this.$http.get('/admin/transactions?page=' + this.page)
        .then(response => {
          ++this.page
          // this.transactions = this.keysToCamelCase(response.data)
          const tmpTransaction = this.keysToCamelCase(response.data.data)
            .map(transaction => {
              switch (transaction.paymentTypeId) {
                case 1: transaction.type = 'Platba kreditem'; break
                case 3: transaction.type = 'Platba při převzetí'; break
                case 4: transaction.type = 'Platba bankovním převodem'; break
                case 5: transaction.type = 'Platba kartou'; break
                case 6: transaction.type = 'Dobití kreditu'; break
                case 7: transaction.type = 'Připsání kreditu'; break
                case 8: transaction.type = 'Vrácení kreditu'; break
                case 9: transaction.type = 'Dobropis'; break
              }
              const c = new Date(transaction.createdAt)
              transaction.createdStr = `${c.getDate()}.${c.getMonth() + 1}.${c.getFullYear()} ${c.getHours()}:${c.getMinutes()}:${c.getSeconds() < 10 ? '0' + c.getSeconds() : c.getSeconds()}`

              // checks DB errors
              transaction.userEmail = transaction.user ? transaction.user.email : ''
              transaction.userFullName = transaction.user ? `${transaction.user.firstName} ${transaction.user.lastName}` : ''
              transaction.adminEmail = transaction.admin ? transaction.admin.email : ''
              transaction.orderId = transaction.orderId || ''

              return transaction
            })
          this.transactions = this.transactions.concat(tmpTransaction)
          this.loading = false
        })
        .catch(err => { console.log(err) })
    },
    showInvoice (item) {
      this.displayedInvoice = item.invoice
      this.invoiceDialog = true
    },
    sortByDate (items, index, isDesc) {
      if (!index.length) {
        return items
      }
      if (index[0] === 'createdStr') {
        items.sort((a, b) => {
          const aDate = new Date(a.createdAt)
          const bDate = new Date(b.createdAt)

          return isDesc[0] ? bDate.getTime() - aDate.getTime() : aDate.getTime() - bDate.getTime()
        })
      } else {
        items.sort((a, b) => {
          if (typeof a[index[0]] === 'number' && typeof b[index[0]] === 'number') {
            if (isDesc[0]) {
              return b[index[0]] - a[index[0]]
            } else {
              return a[index[0]] - b[index[0]]
            }
          } else {
            const val1 = a[index[0]] + ''
            const val2 = b[index[0]] + ''
            if (isDesc[0]) {
              return val2.localeCompare(val1)
            } else {
              return val1.localeCompare(val2)
            }
          }
        })
      }
      return items
    },
    getPaymentTypeColor (id) {
      if ((id >= 1 && id <= 5) || id === 9) {
        return 'payment-type-red'
      } else {
        return 'payment-type-green'
      }
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
  .payment-type-green {
    color: #4caf50;
  }
  .payment-type-green:before{
    content: '+';
  }
  .payment-type-red {
    color: #ff5252;
  }
  .payment-type-red:before{
    content: "-";
  }
</style>
